import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import { fmtDateTime } from "@/lib/format";

const ACTION_LABELS = {
  "project.created": "Project created",
  "update.published": "Update published",
  "alert.broadcast": "Alert broadcast",
  "customer.created": "Customer created",
  "customer.invite_resent": "Customer invite resent",
  "invite.accepted": "Invite accepted",
};

export default function CompanyAudit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/company/audit")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8" data-testid="company-audit-page">
      <PageHeader
        eyebrow="Compliance"
        title="Audit log"
        description="Actions performed within your workspace."
      />

      <DataTable
        testId="company-audit-table"
        columns={[
          { key: "created_at", label: "When", render: (r) => fmtDateTime(r.created_at) },
          {
            key: "action",
            label: "Action",
            render: (r) => (
              <div>
                <div className="font-bold">{ACTION_LABELS[r.action] || r.action}</div>
                <div className="text-xs text-stone-400 font-mono">{r.action}</div>
              </div>
            ),
          },
          { key: "entity_type", label: "Entity", render: (r) => <span className="font-mono text-xs uppercase">{r.entity_type}</span> },
          {
            key: "actor",
            label: "Actor",
            render: (r) => (
              <div>
                <div className="font-semibold">{r.actor_name || r.actor_email || "—"}</div>
                <div className="text-xs text-stone-400 font-mono">{r.actor_role}</div>
              </div>
            ),
          },
          {
            key: "details",
            label: "Details",
            render: (r) =>
              r.details && Object.keys(r.details).length > 0 ? (
                <code className="text-xs text-stone-600">{JSON.stringify(r.details)}</code>
              ) : (
                "—"
              ),
          },
        ]}
        rows={items}
        empty={loading ? "Loading…" : "No audit entries yet."}
      />
    </div>
  );
}
